import Enum from './enum'

class OperationType extends Enum
{
  constructor(value) {
    super(value);
  }
}

OperationType.init({
  ADD: 'Add',
  DELETE: 'Delete',
  UPDATE: 'Update'
}, {
  ADD: 'operation-type.add',
  DELETE: 'operation-type.delete',
  UPDATE: 'operation-type.update'
});

export default OperationType;
